module.exports = __webpack_public_path__ + "static/media/ppLogo.7ff121d8.svg";